/**
 * Width of one slot in a wrapping row. Floored to whole points: an exact
 * fraction (e.g. 127.333 on a 430pt iPhone 15 Pro Max) rounds up in Yoga's
 * float32 layout, the row overflows by a hair, and the last slot wraps.
 */
export const getGridItemWidth = ({
  screenWidth,
  horizontalPadding,
  gap,
  numColumns,
}: {
  screenWidth: number;
  horizontalPadding: number;
  gap: number;
  numColumns: number;
}) =>
  Math.floor(
    (screenWidth - horizontalPadding - gap * (numColumns - 1)) / numColumns,
  );
